import React, { useState } from 'react';
import { Grid, Button, Container, CssBaseline, FormControl, InputLabel, TextField, MenuItem, Select, Typography, Card, Input, CardContent, CardMedia } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import wiki from '../utils/wiki.png'


const Wikipedia = () => {
const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [page_name, setPage] = useState('');
  const theme = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    

    
    formData.append('page_name',page_name);
    // Append the question to the FormData instance
    formData.append('question', question);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/universal-gpt/wikipedia`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setAnswer(data.answer.response);
        console.log(data.answer.response);
      } else {
        console.error('Request failed');
      }
    } catch (error) {
      console.error('Request failed', error);
    }
  };
  return (
    <div style={{ background: theme.palette.background.default, height: '100vh' }}>
      <Navbar />
      <Grid container direction="row" style={{ height: '100%' }}>
        <Grid item xs={2} sm={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={10} sm={10} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Grid item xs={6} sm={6}>
            <Card variant="outlined" style={{ height: '600px', marginTop: "20px", marginLeft: "20px", marginRight: "20px" }}>
              <CardContent>
              <img src={wiki} alt="Your description" style={{width: '60px', height: '60px'}} />
              <br></br>
              <br></br>
                <Typography variant="body2" color="text.secondary" fontSize="20px">
                  Instructions:
                  <ol>
                    <li>Go to any Wikipedia page.</li>
                    
                    <li>Copy the last part</li>
                    <ul>
                        <li>eg: https://en.wikipedia.org/wiki/Messi</li>
                        <li>Copy only 'Messi'</li>
                    </ul>
                    <li>Paste it in the Page box in the form.</li>
                    <li>Enter you question and hit submit.</li>
                  </ol>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6}>

            <Card variant="outlined" style={{ height: '600px', marginTop: "20px", marginRight: "20px" }}>
              <CardContent>
                <form onSubmit={handleSubmit}>
                  <InputLabel htmlFor="page_name" variant="body2" fontSize="20px">Enter Page name</InputLabel>
               
                  
                  <input type="text" id="poge_name" value={page_name} onChange={e => setPage(e.target.value)} style={{ width: "100%", height: "50%" }} />
                  <br></br>
                  <br></br>
                  <InputLabel htmlFor="question" variant="body2" fontSize="20px">Question</InputLabel>

                  <input type="text" id="question" value={question} onChange={e => setQuestion(e.target.value)} style={{ width: "100%", height: "50%" }} />
                  <br></br>
                  <br></br>
                  <button type="submit">Submit</button>
                  <br></br>
                  <br></br>
                </form>
                <div>
                  <Typography variant="body2" color="text.secondary" fontSize="15px"></Typography>
                  {/* <-- Display the file name */}
                  <br />
                  <Typography variant="body2" color="text.secondary" fontSize="15px">Answer:</Typography>
                  <textarea id="freeform" name="freeform" rows="4" cols="50" value={answer} style={{ width: "100%", height: "320px",overflow:"auto" }}></textarea>
                </div>

              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>

    </div>
  )
}

export default Wikipedia